(function () {
  function getTargets() {
    var els = [];

    document
      .querySelectorAll('[data-testid="animated-teaser"]')
      .forEach(function (teaser) {
        var parent = teaser.closest('.needsclick');
        if (parent && !els.includes(parent)) els.push(parent);
      });

    var backToTop = document.getElementById('back-to-top');
    if (backToTop && !els.includes(backToTop)) els.push(backToTop);

    document
      .querySelectorAll('.richpanel-micro')
      .forEach(function (rp) {
        if (rp && !els.includes(rp)) els.push(rp);
      });

    return els;
  }

  function toggleUI(hide) {
    getTargets().forEach(function (el) {
      el.style.setProperty('display', hide ? 'none' : '', 'important');
    });
  }

  function isSearchOpen() {
    return !!document.querySelector('details[open] > .search-modal');
  }

  function observeSearchState() {
    var observer = new MutationObserver(function () {
      toggleUI(isSearchOpen());
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      toggleUI(isSearchOpen());
      observeSearchState();
    });
  } else {
    toggleUI(isSearchOpen());
    observeSearchState();
  }
})();
